import { AlertCircle } from 'lucide-react';
import { Button } from './button';
import { useLanguage } from '@/hooks/useLanguage';

interface ErrorStateProps {
  message: string;
  onRetry?: () => void;
}

export function ErrorState({ message, onRetry }: ErrorStateProps) {
  const { t } = useLanguage();

  return (
    <div className="text-center py-12">
      <AlertCircle className="h-16 w-16 text-red-500 mx-auto mb-4" />
      <h3 className="text-lg font-semibold text-gray-900 mb-2">
        {t('common.error')}
      </h3>
      <p className="text-gray-600 mb-6">
        {message}
      </p>
      {onRetry && (
        <Button onClick={onRetry}>
          {t('common.tryAgain')}
        </Button>
      )}
    </div>
  );
}